const PICS = {
    malePic: require('./malePic.jpg'),
    femalePic: require('./femalePic.jpg'),
    logo: require('./logo.jpg'),
    logoFull: require('./logo-full.jpeg'),
    springInKorea: require('./springInKorea.png'),
    chrisPic: require('./chris.jpg'),
    kyunaPic: require('./kyuna.jpg'),
    shabazzPic: require('./shabazz.jpg'),
    coffeePic: require('./coffeeBlog.jpg'),
    unmannedStores: require('./unmannedStores.png'),
    popUpStore: require('./popUpStore.jpeg'),
    chipotle: require('./chipotle.jpg'),
    parasol: require('./parasol.jpg'),
    queue: require('./queue.jpg'),
    starbucks: require('./starbucks.webp'),
}
export default PICS;